import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ButtonBarGroup.css';
import ButtonDivider from "./ButtonDivider";
const ButtonBarGroup = ({ children, className, groupName }) => {
    return _jsxs("div", { className: `buttonBarGroup ${className !== null && className !== void 0 ? className : ''}`, children: [groupName && _jsx(ButtonDivider, { children: groupName }), children] });
};
export default ButtonBarGroup;
